
// axios
import axios from "axios"
// option
import { ClientOption } from "../../../config/clientOption";

export const PostContactUs = async (data: any) => {
    const { data: response } = await axios.post(`${process.env.REACT_APP_API_URL}contacts`, data, ClientOption);
    return response.data;
}